import { render } from "./Star.vue?vue&type=template&id=21a46a15&scoped=true"
import script from "./Star.vue?vue&type=script&lang=js"
export * from "./Star.vue?vue&type=script&lang=js"

import "./Star.vue?vue&type=style&index=0&id=21a46a15&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a46a15"]])

export default __exports__